module.exports = __webpack_public_path__ + "img/chapter.279b5181.png";